import { Injectable, inject } from '@angular/core';
import {
  MangoEventAnalytics,
  IMangoEventAnalyticsConfig,
} from '@mangosoft/mango-event-analytics';

@Injectable({
  providedIn: 'root',
})
export class MangoEventAnalyticsService {
  private mangoEventAnalytics = inject(MangoEventAnalytics);

  setConfig(config: IMangoEventAnalyticsConfig[]) {
    this.mangoEventAnalytics.setConfig(config);
  }

  sendEvent(event: string, data: any) {
    this.mangoEventAnalytics.sendEvent(event, data);
  }
}
